import { BreakpointKey } from '../HoneycombBreakpoints';
import { TypographyHeadingSize, TypographyHeroSize, TypographySize } from '../HoneycombTypography';

export type TypographyResponsiveSize =
    | (TypographySize | 'inherit')
    | { [key in BreakpointKey]?: TypographySize | 'inherit' };

export type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
export type HeadingTagMap = { [key in TypographyHeadingSize]: HeadingTag };
export type HeroTagMap = { [key in TypographyHeroSize]: HeadingTag };
export type HeadingSizeMap = { [key in HeadingTag]: TypographyHeadingSize };

export const DEFAULT_HEADING_TAG_MAP: HeadingTagMap = {
    '2xs': 'h6',
    xs: 'h5',
    s: 'h4',
    m: 'h3',
    l: 'h2',
    xl: 'h1',
};
export const DEFAULT_HERO_TAG_MAP: HeroTagMap = {
    xs: 'h5',
    s: 'h4',
    m: 'h3',
    l: 'h2',
    xl: 'h2',
    '2xl': 'h1',
    '3xl': 'h1',
};

export const DEFAULT_HEADING_SIZE_MAP: HeadingSizeMap = {
    h1: 'xl',
    h2: 'l',
    h3: 'm',
    h4: 's',
    h5: '2xs',
    h6: '2xs',
};

export type TypographyStyleClasses = 'root';
